/**
 * Mapping de endpoints a regiones de Cloud Functions
 * Si un endpoint no está en este mapping, se usará 'us-central1' por defecto
 */
const ENDPOINT_REGIONS = {
  updateAdsCampaignsInformationFromPlatforms: "us-east1",
  generateRecommendedSettingsPlatform: "us-east1",
  createJob: "us-east1",
  generateImages: "us-east1",
  analyzeCreativeTemplate: "us-east1",
  produceCreativeTemplate: "us-east1",
  saveEditedProduceCreative: "us-east1",
  rehostProduceRowImages: "us-east1",
  renderCreativeTemplatePreview: "us-east1",
  deleteCreativeTemplate: "us-east1",
  previewCreativeTemplateLayer: "us-east1",
  generateCreativeTemplateLayerPrompt: "us-east1",
  saveEditedLayeredImage: "us-east1",
  matchCreativeProductAsset: "us-east1",
  resizeImage: "us-east1",
  detectAndSaveBrandLanguage: "us-east4",
  classifyAdvertiserSeasonalEvents: "us-east4",
  analyzeBusinessProductImages: "us-east4",
  extractBrandInformationFromUrl: "us-east4",
  getAdPreviewAdsCampaigns: "us-east4",
  getTotalMetricsForAllCampaign: "us-east4",
  getKpiTargetCpaStatus: "us-east4",
  animateImage: "us-east4",
  uploadContentsToPlatforms: "us-east4",
  generateVideo: "us-east4",
  createAdsCampaignPlatforms: "us-central1",
  editImage: "us-east1",
  analyzeImageLayers: "us-east1",
  analyzeVideoSubtitles: "us-east4",
  eraseLayerObject: "us-east1",
  editImagesBatch: "us-east1",
  resizeImagesBatch: "us-east1",
  updateAdsCampaignPlatforms: "us-east4",
  getAudienceEstimationAdsCampaigns: "us-east4",
  getStatisticsAdsCampaign: "us-east4",
  getAdsCampaignTrackingIDs: "us-east4",
  submitFeedback: "us-east1",
  savePreActivationForm: "us-central1",
  saveEnterpriseIntakeForm: "us-central1",
  addAdvertiserToAgency: "us-central1",
  deleteAdvertiserFromAgency: "us-central1",
  addCreditsToAgency: "us-central1",
  addCreditsToAdvertiser: "us-central1",
  setBrandUsageAllocations: "us-central1",
  sendEmailFromOwner: "us-central1",
  publishGlobalNotification: "us-central1",
  createOwnerUser: "us-central1",
  reportContent: "us-central1",
  reportedContent: "us-central1",
  approveReportedContent: "us-central1",
  saveByokConfiguration: "us-central1",
  enableCampaignApproval: "us-central1",
  getCampaignApprovalPayload: "us-central1",
  submitCampaignApprovalComment: "us-central1",
  decideCampaignApproval: "us-central1",
  bumpCampaignApprovalDraft: "us-central1",
  getCampaignApprovalAdPreview: "us-central1",
  enableContentApproval: "us-central1",
  bumpContentApprovalDraft: "us-central1",
  getContentApprovalPayload: "us-central1",
  submitContentApprovalComment: "us-central1",
  decideContentApproval: "us-central1",
  sendApprovalReviewLinkEmail: "us-central1",
  addApprovalReviewer: "us-central1",
  getDriveAccessTokenForPicker: "us-central1",
  saveGoogleDriveFilesInStorage: "us-central1",
  manageAnnotations: "us-central1",
  createOwnerLoginAsClientLink: "us-central1",
  exchangeOwnerLoginAsClientLink: "us-central1",
  setFeatureFlag: "us-central1",
  linkAdAccountsToAgency: "us-central1",
  getAgencyLinkingPrompt: "us-central1",
};

/**
 * Obtiene la URL completa de una Cloud Function según su región
 * @param {string} endpoint - Nombre del endpoint (ej: 'generateImages')
 * @returns {string} URL completa de la Cloud Function con la región correcta
 */
export const getCloudFunctionUrl = (endpoint) => {
  const baseUrl = import.meta.env.VITE_CLOUD_FUNCTIONS_URL;
  const region = ENDPOINT_REGIONS[endpoint] || "us-central1";

  return baseUrl.replace("us-central1", region);
};
